export default __webpack_public_path__ + "static/media/28.2007f356.jpg";